import * as React from 'react';
const BlueGradientBackground = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={360} height={458} fill="none" {...props}>
    <g filter="url(#a)" opacity={0.7}>
      <circle cx={243} cy={133} r={225} fill="#E8F2FF" />
    </g>
    <defs>
      <filter
        id="a"
        width={650}
        height={650}
        x={-82}
        y={-192}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_3377_83355" stdDeviation={50} />
      </filter>
    </defs>
  </svg>
);
export default BlueGradientBackground;
